module.exports = __webpack_public_path__ + "static/media/Inter-Bold.d02579fe.woff2";